import React from 'react';
import { MemberOnlyOrganizationWrapper } from 'screens/organizations/context/EditOrganizationProvider';
import OrganizationMembershipsCheckout from 'features/organizations/memberships/checkout';

const OrganizationMembershipsCheckoutScreen = () => (
  <OrganizationMembershipsCheckout />
);

export default OrganizationMembershipsCheckoutScreen;

OrganizationMembershipsCheckoutScreen.getLayout = (page) => (
  <MemberOnlyOrganizationWrapper skipMembershipCheck>
    {page}
  </MemberOnlyOrganizationWrapper>
);
